import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-student-survey-workflow-bar",
    templateUrl: "./student-survey-workflow-bar.component.html",
    styleUrls: ["./student-survey-workflow-bar.component.scss"],
    standalone: false
})
export class StudentSurveyWorkflowBarComponent {
  @Input() isDisabled: boolean = false;
  @Input() isSurveyCompleteDisabled = true;
  @Output() surveyComplete = new EventEmitter();

  constructor() {}

  onSurveyCompleteClick = () => this.surveyComplete.emit();
}
